export default __webpack_public_path__ + "static/media/Spin torre RI_Interactive LightMix0004.588ac639.webp";